import styled, { keyframes } from 'styled-components';
import { fontSize } from '@shared/theme/typeScale';

/*
 * Пока грузится чанк окна Диска. Лежит в основном бандле (импортируется
 * статически из App), поэтому без зависимостей окна.
 */

const fade = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const Screen = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${fontSize.md};
  /* Появляется с задержкой: на быстром канале чанк приходит раньше. */
  animation: ${fade} ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.easeOut} 300ms both;
`;

export function DiskFallback() {
  return (
    <Screen role="status" aria-live="polite">
      Открываем Диск…
    </Screen>
  );
}
